export default "__VITE_ASSET__REVwbTy0__"